/**
 * ============================================================================
 * StickyWidget (MVC feature barrel)
 * ============================================================================
 * Public entry kept at StickyWidget.tsx so layout dynamic imports stay stable.
 * Wire: StickyWidget → SectionErrorBoundary → controller → view
 * ============================================================================
 */
"use client";

import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";
import { useCommonData } from "@/context/CommonDataContext";
import { useStickyWidgetController } from "./controller/useStickyWidgetController";
import StickyWidgetView from "./view/StickyWidgetView";
import type { StickyWidgetProps } from "./model/stickyWidget.types";

export type {
  StickyWidgetProps,
  StickyWidgetViewModel,
} from "./model/stickyWidget.types";

function StickyWidgetInner(props: StickyWidgetProps) {
  // Common data comes from the root layout's CommonDataProvider; explicit
  // props still win if a caller passes them.
  const { stickyWidget, modalThirtySecondImage } = useCommonData();
  const viewModel = useStickyWidgetController({
    stickyWidget,
    modalThirtySecondImage,
    ...props,
  });
  if (!viewModel) return null;
  return <StickyWidgetView {...viewModel} />;
}

export default function StickyWidget(props: StickyWidgetProps) {
  return (
    <SectionErrorBoundary sectionName="StickyWidget">
      <StickyWidgetInner {...props} />
    </SectionErrorBoundary>
  );
}
